import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles} from '@webs/components-library/theming';

@customElement('webs-quote')
export class Quote extends LitElement {
  static styles = [
    normalizeStyles,
    containerStyles,
    css`


      .quote + .quoter {
        margin-top: 1.2rem;
      }

      .quote, .quoter-name {
        font-family: var(--font-family-alternative);
        font-size: 1.05rem;
        font-weight: var(--font-weight-base);
        line-height: 1.5;
        margin: 0;
      }

      .avatar {
        border-radius: 50%;
        height: 40px;
        object-fit: cover;
        margin-right: .8rem;
        width: 40px;
      }

      .quoter {
        display: flex;
      }

      .quoter-details {
      }

      .quoter-details p {
        margin: 0;
      }

      .quoter-details p:nth-of-type(n+2){
        margin: 3px 0 0;
      }

      .extra-info {
        color: #A8A39F;
        font-family: var(--font-family-alternative);
        font-size: .6rem;
        font-weight: var(--font-weight-base);
        line-height: 1.3;
      }
    `
  ];

  @property()
  quote: string;

  @property()
  avatar: string;

  @property()
  quoter: string

  @property({attribute: 'extra-info'})
  extraInfo: string

  protected render(): unknown {
    return html`
      ${this.quote ? html`<p class="quote">${this.quote}</p>` : ''}

      ${this.avatar || this.quoter || this.extraInfo ? html`
        <div class="quoter">
          ${this.avatar ? html`
            <img class="avatar" src="${this.avatar}" alt="${this.quoter}" loading="lazy" width="40">
          ` : ''}

          ${this.quoter || this.extraInfo ? html`
            <div class="quoter-details">
              ${this.quoter ? html`<p class="quoter-name">${this.quoter}</p>` : ''}
              ${this.extraInfo ? html`<p class="extra-info">${this.extraInfo}</p>` : ''}
            </div>
          ` : ''}
        </div>
      ` : ''}
    `;
  }
}
